"use client"

import styled, { css } from "styled-components"
import { IntentPrefetchLink } from "@/components/Link"

import { hideScrollbar } from "@/design/utils"

export const Nav = styled.nav`
  ${({ theme }) => {
    const { colors } = theme
    return css`
      display: flex;
      background-color: ${colors.content.bg};
    `
  }}
`

export const MainNavigation = styled.div`
  ${({ theme }) => {
    const { spaces } = theme
    return css`
      padding: ${spaces.small};
    `
  }}
`

export const LogoLink = styled(IntentPrefetchLink)`
  ${({ theme, $sideNavOpen }) => {
    const { spaces } = theme
    const { normal: iconSize } = theme.widgets.navigation.sizes.icons

    const iconWidth = `${iconSize} + (2 * ${spaces.small})`
    const paddingLogo = `calc(${spaces.large} + ${iconWidth})`

    return css`
      display: block;
      padding-top: ${!$sideNavOpen && spaces.large};
      padding-bottom: ${spaces.small};

      img {
        margin-inline: ${!$sideNavOpen && "auto"};
        margin-left: ${$sideNavOpen && paddingLogo};
      }
    `
  }}
`

export const ScrollableItems = styled.div`
  ${({ theme, $sideNavOpen }) => {
    const { spaces } = theme
    const { height, logo, maxWidth } = theme.widgets.navigation.sizes

    const paddingContainer = `(2 * ${spaces.small})`
    const paddingLogo = $sideNavOpen ? spaces.small : `(${spaces.large} + ${spaces.small})`
    const logoHeight = $sideNavOpen ? logo.big.height : logo.small.height

    return css`
      position: sticky;
      width: max-content;
      max-width: ${maxWidth};
      height: calc(${height} - ${logoHeight} - ${paddingContainer} - ${paddingLogo});
      overflow-y: scroll;
      display: flex;
      flex-direction: column;
      align-items: center;
      ${hideScrollbar()}
    `
  }}
`

export const SubNavigationWrapper = styled.div`
  ${({ theme }) => {
    const { spaces } = theme

    return css`
      display: flex;
      flex-direction: column;
      padding: ${spaces.small};
    `
  }}
`
